import React from 'react';
import BlogIntro from "./BlogIntro";
import ContactSection from "./ContactSection";
import Footer from "./Footer"; // ✅ Make sure the path is correct

const Blog = () => {
  return (
    <>
      <BlogIntro />
      <ContactSection />
      <Footer />
    </>
  );
};

export default Blog;
